module.exports = __webpack_public_path__ + "media/images/home/close-8de0b283c0566b3d609b014ce5c76e3a.png";